import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import { BookDetailsFormWrapperValues } from "src/models/BookDetailsFormWrapper.model";

type Props = {
  formikProps: FormikProps<BookDetailsFormWrapperValues>;
  bookIssued: any;
};

const BookDetailsForm = ({ formikProps }: Props) => {
  const { values, setFieldValue, isSubmitting, handleSubmit } = formikProps;

  const handleToggle = (index: number) => {
    const updatedBooks = [...values?.bookIssued];
    updatedBooks[index].isIssued = !updatedBooks[index].isIssued;
    setFieldValue("bookIssued", updatedBooks);
  };

  const confirmedIssuedBooks = values?.bookIssued?.filter(
    (book) => book?.originallyIssued === true
  );

  const availableBooks = values?.bookIssued?.filter(
    (book) => book?.originallyIssued !== true
  );

  // ✅ Check if user made any changes to toggle state
  const hasChanges = values.bookIssued.some(
    (book) => book.isIssued !== book.originallyIssued
  );

  // ✅ Also check if there are available books
  const hasAvailableBooks = availableBooks?.length > 0;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex flex-col gap-4">
        {/* Already Issued */}
        <div className="flex flex-col gap-2">
          <h2 className="text-sm my-4 font-semibold text-green-700">
            Already Issued
          </h2>
          {confirmedIssuedBooks?.map((book, i) => (
            <div
              key={i}
              className="flex items-center gap-3 border p-2 rounded-md shadow-sm bg-green-50"
            >
              <span>Book Name: {book?.bookName}</span>
              <span className="text-xs text-green-700 font-medium">
                (Issued)
              </span>
            </div>
          ))}
        </div>

        {/* Available to Issue */}
        <div className="flex flex-col gap-2">
          <h2 className="text-sm my-4 font-semibold text-red-700">
            Available to Issue
          </h2>
          {availableBooks?.map((book, i) => {
            const originalIndex = values?.bookIssued?.findIndex(
              (b) => b?.bookId === book?.bookId
            );
            return (
              <label
                key={i}
                className="flex items-center gap-3 border p-2 rounded-md shadow-sm"
              >
                <input
                  type="checkbox"
                  checked={book?.isIssued}
                  onChange={() => handleToggle(originalIndex)}
                />
                <span>Book Name: {book?.bookName}</span>
              </label>
            );
          })}
          {availableBooks?.length === 0 && (
            <div className="text-sm text-gray-500">No books available to issue.</div>
          )}
        </div>
      </div>

      {/* ✅ Only show update button if there are changes AND available books */}
      {hasChanges && hasAvailableBooks && (
        <div className="flex justify-end mt-4">
          <ATMLoadingButton
            className="w-32"
            isLoading={isSubmitting}
            type="submit"
          >
            Update
          </ATMLoadingButton>
        </div>
      )}
    </div>
  );
};

export default BookDetailsForm;
